import { getFirstLetterOfString } from '@mais-retorno-front/helpers/util-helpers';
import { AxiosInstance } from 'axios';

interface ITermsOfDayResponse {
  excerpt: string;
  link: string;
  title: string;
  related_terms: {
    link: string;
    title: string;
  }[];
}

interface IResponse {
  data: {
    TermOfDay: {
      term: {
        data: {
          attributes: {
            term: string;
            excerpt: string;
            slug: string;
            path: string;
          };
        };
      };
      related_terms: {
        data: {
          attributes: {
            term: string;
            slug: string;
            path: string;
          };
        }[];
      };
    };
  };
}

export class GetTermOfDayUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(): Promise<ITermsOfDayResponse> {
    const { data } = await this.http.post<IResponse>('', {
      query: `
        query termOfDay {
          TermOfDay {
            term {
              data {
                attributes {
                  term
                  excerpt
                  slug
                  path
                }
              }
            }
            related_terms {
              data {
                attributes {
                  term
                  slug
                  path
                }
              }
            }
          }
        }
      `,
    });

    const term = data?.data?.TermOfDay?.term?.data?.attributes;
    const related_terms = data.data.TermOfDay?.related_terms?.data;

    if (!term || !related_terms) {
      return {
        excerpt: null,
        link: null,
        title: null,
        related_terms: null,
      };
    }

    return {
      excerpt: term?.excerpt || null,
      link: `${term?.path}/${getFirstLetterOfString(term?.slug)}/${term?.slug}`,
      title: term?.term || null,
      related_terms: related_terms?.map((related_term) => {
        return {
          link:
            `${related_term?.attributes?.path}/${getFirstLetterOfString(
              related_term?.attributes?.slug
            )}/${related_term?.attributes?.slug}` || null,
          title: related_term?.attributes?.term || null,
        };
      }),
    };
  }
}
